import LazyWrapper from 'bz-core-controls/controls/lazy';
import { lazy } from 'react';

const plugins = {
  routes: {
    settings: {
      setup: [LazyWrapper(lazy(() => import('./settings/routes')))]
    }
  },

  settingsSetupMenu: [LazyWrapper(lazy(() => import('./settings/classes/classes-menu-item')))]
};

export default plugins;
